module.exports = __webpack_public_path__ + "img/105ne.6d4499a1.svg";